export default __webpack_public_path__ + "static/media/Ford_Takeover.e749e2ed.jpg";